// START A/B TEST PLGRWEB-1380 - Browse Filter on "All"
import { AbTest } from 'abTests/lib/AbTest';
import browseFilterDropBox from 'templates/__browseFilterDropBox.tpl';
import HttpService from '../../services/HttpService';
import { BrowseFilterDropdown } from '../../components/dropdownFilters/BrowseFilterDropdown';

const FILTER_VARIANT = 'filter';
const BrowseFilterOnAllSettings = CBS?.AbTestsConfigs?.modules?.BrowseFilterOnAll;
export default class BrowseFilterOnAll extends AbTest {
    constructor(pageType) {
        super(BrowseFilterOnAllSettings);
        this.contentType = pageType;
        this.mainContainer = document.querySelector('#main-container');
        this.subNavWrapper = document.querySelector('#subnav');
        this.subNavMenu = this.subNavWrapper.querySelector('.subnav__items');
        this.activeItem = this.subNavMenu.querySelector('li > a.active');
        this.activeCategory = this.activeItem.dataset.category ?? '';
        this.genreDropdown;
        this.brandDropdown;
        this.implement();
        this.onRun();
    }

    fetchFilterOptions() {
        const http = new HttpService();
        const browseFiltersUrl = '/' + this.contentType + 's_xhr/browseFilters/';
        return http.doGet(browseFiltersUrl, {});
    }

    onRun() {
        // display filter for "All" shows/movies tab (category may or may not have a trailing slash)
        if (this.activeItem && (this.activeCategory === 'all' || this.activeCategory === 'all/')) {
            // fetch genres and brands as filter options
            this.fetchFilterOptions().then((response) => {
                if (response?.success && response?.data?.filters) {
                    const genresList = response.data.filters.genres;
                    // only display brand filters for "All Shows" page
                    const brandsList =
                        this.contentType === 'show' ? response.data.filters.brands : false;

                    // render browse filter dropboxes
                    let temp = document.createElement('div');
                    temp.innerHTML = browseFilterDropBox({
                        genres: genresList,
                        brands: brandsList,
                    });
                    let div = temp.querySelector('div');
                    this.mainContainer.prepend(div);

                    // init dropdown logic & event listeners
                    this.genreDropdown = new BrowseFilterDropdown();
                    this.genreDropdown.setContentType(this.contentType);
                    this.genreDropdown
                        .setMount($(this.mainContainer).find('#genre-dropdown'))
                        .build();

                    // add "clear all" button event listener
                    this.genreDropdown.handleClearAll();
                    // track when user invokes genre dropdown
                    this.genreDropdown.trackGenreFilterDropdown();

                    // only allow brands dropdown for shows
                    if (this.contentType === 'show') {
                        this.brandDropdown = new BrowseFilterDropdown();
                        this.brandDropdown.setContentType(this.contentType);
                        this.brandDropdown
                            .setMount($(this.mainContainer).find('#brand-dropdown'))
                            .build();
                        // track when user invokes brands dropdown
                        this.brandDropdown.trackBrandsFilterDropdown();
                    }
                }
            });
        }
    }
}

const hasAllFilterVariant = () => {
    return CBS?.AbTestsConfigs?.modules?.BrowseFilterOnAll?.activeVariant === FILTER_VARIANT;
};

export const initializeBrowseFilterAll = (pageType) => {
    try {
        if (hasAllFilterVariant()) {
            new BrowseFilterOnAll(pageType);
        }
    } catch (e) {
        console.error('Browse filtering failed to load', e);
    }
};
// END A/B TEST PLGRWEB-1380 - Browse Filter on "All"
